import {DatosEnvioMora} from "../modelo/EnvioReporteMora";

export const ENVIAR_SAT_MORA = "ENVIAR_SAT_MORA";
export const ENVIAR_SAT_MASIVO_MORA= "ENVIAR_SAT_MASIVO_MORA";
export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const ERROR_ENVIO_MORA_INDIVIDUAL = "ERROR_ENVIO_MORA_INDIVIDUAL";
export const ERROR_ENVIO_MORA_MASIVO = "ERROR_ENVIO_MORA_MASIVO";
export const ENVIO_EXITOSO_MORA = "ENVIO_EXITOSO_MORA";
export const ENVIO_EXITOSO_MORA_MASIVO = "ENVIO_EXITOSO_MORA_MASIVO";
export const DESCARGAR_PLANTILLA_MASIVO_MORA = "DESCARGAR_PLANTILLA_MASIVO_MORA";
export const PLANTILLA_MORA_OBTENIDA = "PLANTILLA_MORA_OBTENIDA";
export const ERROR_OBTENIENDO_PLANTILLA_MORA = "ERROR_OBTENIENDO_PLANTILLA_MORA";
export const LIMPIAR_MENSAJES_MORA = "LIMPIAR_MENSAJES_MORA";

export const enviarSATMoraIndividual = (datosEnvioMora: DatosEnvioMora) => ({ type: ENVIAR_SAT_MORA, datosEnvioMora });
export const enviarSATMoraMasivo = (archivoEnvioMora: File) => ({ type: ENVIAR_SAT_MASIVO_MORA, archivoEnvioMora});
export const errorAutorizacion = () => ({ type: ERROR_AUTORIZACION});
export const errorEnvioMoraIndividual = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_MORA_INDIVIDUAL, mensajeRespuesta});
export const errorEnvioMoraMasivo = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_MORA_MASIVO, mensajeRespuesta});
export const envioMoraExito = (poliza: string, dni: string, consecutivoMoraNota: number) => ({ type: ENVIO_EXITOSO_MORA, poliza, dni, consecutivoMoraNota});
export const envioMoraMasivoExito = (consecutivoMoraNota: number) => ({ type: ENVIO_EXITOSO_MORA_MASIVO, consecutivoMoraNota});
export const descargarPlantillaMasivoMora = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_MORA});
export const plantillaMoraObtenida = () => ({type: PLANTILLA_MORA_OBTENIDA});
export const errorObteniendoPlantillaMora = () => ({type: ERROR_OBTENIENDO_PLANTILLA_MORA});
export const limpiarMensajesMora = () => ({type: LIMPIAR_MENSAJES_MORA});








// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_mora/modulos/procesarMoraActions.ts